/** Pins a header to the top of `TimeScroller`, above the tiles beneath it. */
export const STICKY_HEADER_SX = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: 'background.paper',
} as const
